import type { IAppEnvironment } from '@bp/shared/typings';

export const environment: Partial<IAppEnvironment> = {
	api: 'https://dash.bridgerpay.dev',
};
